import _ from 'lodash'

export const getVisibleExportColumns = (columns, visibleColumns) => {
  if (!visibleColumns) return columns

  const visibleColumnIds = new Set(visibleColumns.map(column => column.id))
  return columns.filter(column => visibleColumnIds.has(column.item) || visibleColumnIds.has(column.id))
}

export const projectExportData = (data, visibleColumns) => {
  if (!visibleColumns) return data

  const paths = visibleColumns.map(column => column.columnDef?.exportKey || column.columnDef?.accessorKey || column.id)
  const projectRow = row => paths.reduce((result, path) => {
    if (_.has(row, path)) _.set(result, path, _.get(row, path))
    return result
  }, {})

  if (Array.isArray(data)) return data.map(projectRow)

  return Object.fromEntries(Object.entries(data).map(([key, value]) => [
    key,
    Array.isArray(value) ? value.map(projectRow) : value
  ]))
}
